var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    className: "css-1x6bo8q",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4h4.4c.56 0 .84 0 1.05.1a1 1 0 0 1 .44.45c.11.21.11.49.11 1.05v1.1c0 .56 0 .84-.1 1.05a1 1 0 0 1-.45.44c-.21.11-.49.11-1.05.11H12A3.7 3.7 0 0 0 8.3 12v24a3.7 3.7 0 0 0 3.7 3.7h24a3.7 3.7 0 0 0 3.7-3.7v-4.4c0-.56 0-.84.1-1.05a1 1 0 0 1 .45-.44c.21-.11.49-.11 1.05-.11h1.1c.56 0 .84 0 1.05.1a1 1 0 0 1 .44.45c.11.21.11.49.11 1.05V36a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.54 5.77c0-.56 0-.84.1-1.05a1 1 0 0 1 .44-.44c.22-.1.5-.1 1.06-.1h12.54c1.18 0 2.15.95 2.15 2.14v12.54c0 .56 0 .84-.11 1.06a1 1 0 0 1-.44.44c-.21.1-.5.1-1.05.1h-1.1c-.56 0-.84 0-1.06-.1a1 1 0 0 1-.43-.44c-.11-.22-.11-.5-.11-1.06v-7.35L26.65 24.4c-.4.4-.6.6-.82.67a1 1 0 0 1-.62 0c-.23-.08-.43-.28-.82-.67l-.78-.78c-.4-.4-.6-.6-.67-.82a1 1 0 0 1 0-.62c.08-.23.27-.43.67-.82L36.5 8.47h-7.35c-.56 0-.84 0-1.06-.1a1 1 0 0 1-.44-.44c-.1-.22-.1-.5-.1-1.06v-1.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingShare);
export default __webpack_public_path__ + "static/media/setting-share.26a80d53980d57ce27a634e688675c7f.svg";
export { ForwardRef as ReactComponent };